"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactStatus = void 0;
var ContactStatus;
(function (ContactStatus) {
    ContactStatus["Active"] = "active";
    ContactStatus["Inactive"] = "inactive";
})(ContactStatus = exports.ContactStatus || (exports.ContactStatus = {}));
//# sourceMappingURL=ContactStatus.js.map